import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  customer_id: '2',
  cart_item_id: '207',
  order_item_id: '',
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCustomerId: (state, action) => {
      state.customer_id = action.payload;
    },
    setCartItemId: (state, action) => {
      state.cart_item_id = action.payload;
    },
    setOrderItemId: (state, action) => {
      state.order_item_id = action.payload;
    },
    resetCart: (state) => {
      state.customer_id = '';
      state.cart_item_id = '';
      state.order_item_id = '';
    },
  },
});

export const { setCustomerId, setCartItemId, setOrderItemId, resetCart } = cartSlice.actions;

export default cartSlice.reducer;
